export default {
  navigationBarTitleText: intl.get('pdfView.title')
};
